import { render, staticRenderFns } from "./PlantPresent.vue?vue&type=template&id=1c8027b8&"
import script from "./PlantPresent.vue?vue&type=script&lang=js&"
export * from "./PlantPresent.vue?vue&type=script&lang=js&"
import style0 from "./PlantPresent.vue?vue&type=style&index=0&id=1c8027b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports